import * as React from "react";
import {
  Box,
  LinearProgress,
  Rating,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import {
  useGetTalentByIdQuery,
} from "../../services/talent.service";
import { useTitle } from "../../hooks/useTitle";
import { useGetTalentReviewsQuery } from "../../services/review.service";
import { CardBase } from "../../components/global";
import dayjs from "dayjs";
import { useUILabel } from "../../hooks/useUILabel";

const TalentReviewsPage = () => {
  const { talentId } = useParams();
  const reviewsForLabel = useUILabel("talent.reviewsFor");
  const talentLabel = useUILabel("talent.talent");
  const noReviewYetLabel = useUILabel("talent.noReviewYet");
  const untitledProjectLabel = useUILabel("talent.untitledProject");
  const unknownCompanyLabel = useUILabel("talent.unknownCompany");

  const { data: talent } = useGetTalentByIdQuery(parseInt(talentId!), {
    skip: !talentId,
  });

  const { data, isLoading, isFetching } = useGetTalentReviewsQuery(
    parseInt(talentId!),
    {
      skip: !talentId,
    }
  );

  useTitle(
    `Independent Professional #${talent?.id}`,
    `${talent?.first_name} ${talent?.last_name}`
  );

  return (
    <Box sx={{ px: { xs: 0, sm: 3 }, py: 3 }}>
      <CardBase
        title={`${reviewsForLabel} ${talent?.full_name || talentLabel}`}
        useGlassCard={true}
        nested={false}
        sx={{ mb: { xs: 2, sm: 3 } }}
      >
        {(isLoading || isFetching) && <LinearProgress sx={{ mt: 1 }} />}
        {data?.length == 0 && (
          <Box sx={{ py: 3 }}>
            <Typography color={"text.disabled"}>{noReviewYetLabel}</Typography>
          </Box>
        )}
      </CardBase>
      {data?.map((review, index) => (
        <CardBase
          key={review.id || index}
          title={`#${review.project?.id} ${review?.project?.title || untitledProjectLabel}`}
          useGlassCard={true}
          nested={false}
          sx={{ mt: { xs: 1.5, sm: 2 }, mb: { xs: 5, md: 7 } }}
        >
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mb: 1,
                fontSize: { xs: "0.875rem", sm: "0.875rem" },
                wordBreak: "break-word"
              }}
            >
              {review.project?.company?.name || unknownCompanyLabel}
            </Typography>
            <Rating
              value={review.star}
              readOnly={true}
              sx={{ mb: 2 }}
              size="small"
            />
            <Box>
              <Typography
                sx={{
                  fontStyle: "italic",
                  mb: 1,
                  fontSize: { xs: "0.875rem", sm: "0.9375rem" },
                  wordBreak: "break-word",
                  lineHeight: 1.6
                }}
              >
                {review.review}
              </Typography>
              <Typography
                variant="caption"
                color={"text.disabled"}
                sx={{
                  fontSize: { xs: "0.7rem", sm: "0.75rem" }
                }}
              >
                {dayjs(review.created_at).format("MMM DD, YYYY hh:mm A z")}
              </Typography>
            </Box>
          </Box>
        </CardBase>
      ))}
    </Box>
  );
};
export default TalentReviewsPage;
